import { useForm } from '../../context/FormContext'
import FormField from '../ui/FormField'
import Select from '../ui/Select'
import ar from '../../locales/ar.json'

const t = ar.step1

const RELATIONS = Object.keys(t.relations).map((v) => ({ value: v, label: v }))

export default function Step1_Applicant() {
  const { state, updateField } = useForm()
  const { formData, errors } = state

  const field = (id) => ({
    id,
    error: errors[id],
  })

  return (
    <div>
      <h2 className="section-title">
        <span className="bg-primary-700 text-white w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">١</span>
        {t.sectionTitle}
      </h2>
      <p className="text-sm text-stone-500 mb-6">{t.sectionHint}</p>

      {/* Full name */}
      <FormField {...field('name_applicant')} label={t.name_applicant} required>
        <input
          id="name_applicant"
          type="text"
          value={formData.name_applicant}
          onChange={(e) => updateField('name_applicant', e.target.value)}
          className="input-base"
          aria-required="true"
          aria-describedby={errors.name_applicant ? 'name_applicant-error' : undefined}
          autoComplete="name"
          dir="rtl"
        />
      </FormField>

      {/* Relation */}
      <Select
        {...field('relation_applicant')}
        label={t.relation_applicant}
        required
        value={formData.relation_applicant}
        onChange={(v) => updateField('relation_applicant', v)}
        options={RELATIONS}
        placeholder={ar.app.select}
      />

      {/* Primary phone */}
      <FormField {...field('phone_primary')} label={t.phone_primary} required>
        <input
          id="phone_primary"
          type="tel"
          value={formData.phone_primary}
          onChange={(e) => updateField('phone_primary', e.target.value)}
          className="input-base"
          aria-required="true"
          aria-describedby={errors.phone_primary ? 'phone_primary-error' : undefined}
          dir="ltr"
          style={{ textAlign: 'right' }}
          placeholder="+963 912 345 678"
          autoComplete="tel"
        />
      </FormField>

      {/* Secondary phone */}
      <FormField {...field('phone_secondary')} label={t.phone_secondary}>
        <input
          id="phone_secondary"
          type="tel"
          value={formData.phone_secondary}
          onChange={(e) => updateField('phone_secondary', e.target.value)}
          className="input-base"
          dir="ltr"
          style={{ textAlign: 'right' }}
          placeholder="+963 ..."
          autoComplete="tel"
        />
      </FormField>

      {/* Area */}
      <FormField {...field('area_applicant')} label={t.area_applicant}>
        <input
          id="area_applicant"
          type="text"
          value={formData.area_applicant}
          onChange={(e) => updateField('area_applicant', e.target.value)}
          className="input-base"
          dir="rtl"
          placeholder="مثال: دمشق — التضامن"
        />
      </FormField>
    </div>
  )
}
